import type { AudioAdapter } from "./audio";
import type { HapticsAdapter } from "./haptics";
import type { StorageAdapter } from "./storage";
import { WebAudioAdapter } from "./audio";
import { WebHapticsAdapter } from "./haptics";
import { LocalStorageAdapter } from "./storage";

/** Абстракция платформенных API. */
export interface Platform {
  readonly haptics: HapticsAdapter;
  readonly storage: StorageAdapter;
  readonly audio: AudioAdapter;
}

export type PlatformKind = "web" | "ios" | "android";

/** Определяет текущую платформу (Capacitor или web). */
export const detectPlatform = (): PlatformKind => {
  const w = window as unknown as {
    Capacitor?: {
      isNativePlatform?: () => boolean;
      getPlatform?: () => string;
    };
  };
  if (w.Capacitor?.isNativePlatform?.()) {
    const p = w.Capacitor.getPlatform?.();
    if (p === "ios") return "ios";
    if (p === "android") return "android";
  }
  return "web";
};

const createWebPlatform = (): Platform => ({
  haptics: new WebHapticsAdapter(),
  storage: new LocalStorageAdapter(),
  audio: new WebAudioAdapter(),
});

/**
 * Создаёт Platform-фасад с правильными адаптерами для текущей среды.
 * Web — синхронно. Native (Capacitor) — пока тоже падает на web (заглушки).
 * После интеграции Capacitor — раскомментируй native-branch.
 */
export const createPlatform = (): Platform => {
  const kind = detectPlatform();
  if (kind !== "web") {
    // TODO: когда интегрируем Capacitor:
    // const { CapacitorHapticsAdapter, CapacitorStorageAdapter, CapacitorAudioAdapter } =
    //   await import("./capacitor-stub");
    // return {
    //   haptics: new CapacitorHapticsAdapter(),
    //   storage: new CapacitorStorageAdapter(),
    //   audio: new CapacitorAudioAdapter(),
    // };
    // Пока — web-impl как fallback (в Capacitor WebView большинство web-API работают).
    return createWebPlatform();
  }
  return createWebPlatform();
};
